function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Message } from '@wegic/ui';
import { useEffect, useState } from 'react';
import { INVITE_CODE } from '@/const/constant';
import { getInviteCodeInfo, getIpIsBlock } from '@/services';
import styles from '../components/LoginForm/index.module.less';
/**
 * 邀请码提示消息
 */ export function useInviteCodeMessage() {
    var _useState = _sliced_to_array(useState(null), 2), inviteCode = _useState[0], setInviteCode = _useState[1];
    // 获取邀请码
    useEffect(function() {
        var searchParams = new URLSearchParams(window.location.search);
        var code = searchParams.get(INVITE_CODE);
        setInviteCode(code);
    }, []);
    useEffect(function() {
        if (!inviteCode) {
            return;
        }
        var inviteMessage = null;
        // 获取邀请码信息
        var fetchInviteInfo = function() {
            return _async_to_generator(function() {
                var inviteRes, inviteData, _ref, _ipRes_data, ipRes, freeRightBlock, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                getInviteCodeInfo(inviteCode)
                            ];
                        case 1:
                            inviteRes = _state.sent();
                            inviteData = inviteRes.data;
                            if (!inviteData) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                getIpIsBlock()
                            ];
                        case 2:
                            ipRes = _state.sent();
                            freeRightBlock = (_ref = (_ipRes_data = ipRes.data) === null || _ipRes_data === void 0 ? void 0 : _ipRes_data.freeRightBlock) !== null && _ref !== void 0 ? _ref : false;
                            if (!freeRightBlock) {
                                if (inviteData.exhausted) {
                                    // 邀请码已用完
                                    inviteMessage = Message.normal({
                                        content: /*#__PURE__*/ _jsx("span", {
                                            dangerouslySetInnerHTML: {
                                                __html: intl.get('Login_Share_InviteUnavailable', {
                                                    inviter: inviteData.inviterName
                                                })
                                            }
                                        }),
                                        duration: 99999999,
                                        className: styles['invite-message--unavailable']
                                    });
                                } else {
                                    // 邀请码可用
                                    inviteMessage = Message.normal({
                                        content: intl.inject('Login_Share_InviteAvailable', {
                                            inviter: /*#__PURE__*/ _jsx("strong", {
                                                style: {
                                                    marginLeft: '4px'
                                                },
                                                children: inviteData.inviterName
                                            }),
                                            credits: /*#__PURE__*/ _jsxs("div", {
                                                className: styles['invite-credits'],
                                                children: [
                                                    /*#__PURE__*/ _jsx("strong", {
                                                        children: intl.get('Common_Text_Credits', {
                                                            num: inviteData.inviteCredit
                                                        })
                                                    }),
                                                    ' + ',
                                                    /*#__PURE__*/ _jsx("strong", {
                                                        children: intl.get('Common_Text_Discount', {
                                                            num: '10%'
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        duration: 99999999,
                                        className: styles['invite-message--available']
                                    });
                                }
                            }
                            _state.label = 3;
                        case 3:
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            console.error('Failed to fetch invite code info:', error);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        fetchInviteInfo();
        return function() {
            inviteMessage === null || inviteMessage === void 0 ? void 0 : inviteMessage();
        };
    }, [
        inviteCode
    ]);
}
